/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Tabs } from '../../../UiKit';
import styled from 'styled-components';
import { reasonModel } from '../../../api';
import { Back, TableBooking } from 'sushiweb/Icons';
import { grey } from 'sushiweb/tokens/color';
import { InvalidSearchImg, backArrow } from '../../../images/images';
import { EmptyState } from '../../commons';
import { ActiveAction as ActiveActionContent } from './ActiveActionContent/ActiveActionContent';
import { Card } from '../ReportIssue/Issues/common';
import toast from 'react-hot-toast';
import tone from '../../../audio/notification.mp3';
import { links, POLL_INTERVAL, TASK_STATUSES } from './constants';
import { useMutationCall, useQueryCall } from '../../../api/react-client';
import { useClient } from '../../../api/api-client';
import { lifelineEndPoints } from '../../../api/end-points';
import { useDispatch, useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { TAB_INDEXES } from './constants';
import { isPlayGroundMode } from '../../../utils/CookieToken';
import { IssueClickEvent } from '../../../analytics/raise-an-issue/events';
import {
  MetricsForJumboEvent,
  RFO_CACR_REASON_ID,
} from '../../../analytics/constants';
import {
  RfoApplicableReasonsFetchedEvent,
  RfoCacrOptionClickedEvent,
  RfoIssueInfoResponseEvent,
} from '../../../analytics/rfo/events';
import { closeActionView } from '../../../store/basicOrder/actions';
import SidebarUI from './SidebarUI';
import LoadingUI from './LoadingUI';
import { IS_SIDEBAR_CLOSE } from '../../../store/basicOrder/reducers';
import { DSR_COMMENT } from '../ReportIssue/Issues/OrderSpilled/constants';

const dashboardMode = window.dashboard.mode;

// test

const playNotificationSound = () => {
  const audio = new Audio(tone);
  audio?.play().catch((error) => {
    Sentry.captureException(error, {
      tags: { section: 'audio-playback' },
      extra: { message: 'Audio playback failed' },
    });
  });
};

const getTasksEndpoint = (orderId, offset) =>
  `${lifelineEndPoints.GET_TASKS}?order_id=${orderId}&offset=${offset}`;

const getLiveOrderConfig = (orderId) =>
  `${lifelineEndPoints.GET_LIVE_ORDER_CONFIG}?order_id=${orderId}`;

const PLAYGROUND_UPDATE_TASK_ENDPOINT =
  'playground/live_order_task/update_order_task';

export const ActionsView = ({
  orderId = null,
  cartId = null,
  userId = null,
  isSmartPlug = false,
  resetSmartplugState = false,
  isTimelineUpdated = false,
  setIsTimelineUpdated = () => {},
  handleCardLink = () => {},
  setShowIssuesBox = () => {},
}) => {
  const client = useClient();
  const issueRefID = useRef(null);
  const actionRefID = useRef(null);

  // Pick local storage value here too
  const isActionViewClose = useSelector((state) => {
    return state.basicOrderState?.isActionViewClose;
  }); // Ensure correct state mapping

  const { isLiveOrdersViewEnabled, orders } = useSelector((state) => ({
    isLiveOrdersViewEnabled: state?.ordersState?.isLiveOrdersViewEnabled,
    orders: state?.ordersState?.orders,
  }));

  const [actions, setActions] = useState([]);
  const [currentAction, setCurrentAction] = useState(null);
  const [data, setData] = useState({});

  const dispatch = useDispatch();
  const isNewUI = useSelector((state) => state.ordersState?.isNewUI);

  // Live Order related states
  const [isLiveOrderViewAllowed, setIsLiveOrderViewAllowed] = useState(false);
  const [liveOrderTasks, setLiveOrderTasks] = useState([]);
  const [currentTaskListOffset, setCurrentTaskListOffset] = useState(0);
  const [isUpdatingTask, setIsUpdatingTask] = useState(false);
  const [updateTaskList, setUpdateTaskList] = useState(true);
  const [newTasksCount, setNewTasksCount] = useState(0);

  const [filteredItems, setFilteredItems] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('Something went wrong!');
  const [searchedError, setSearchedError] = useState(false);
  const [isResolutionService, setIsResolutionService] = useState(false);
  const [complaintType, setcomplaintType] = useState(null);

  const [activeActionIndex, setActiveActionIndex] = useState(() => {
    // Determine initial tab based on conditions
    return isLiveOrdersViewEnabled &&
      orders?.some(
        ({ order, task_section }) =>
          order?.order_id === orderId &&
          task_section?.allow_live_order_task_section,
      )
      ? TAB_INDEXES.LIVE_ORDER
      : TAB_INDEXES.REPORT_ISSUE;
  });

  const currentIndex = actions?.length > 0 ? actions?.length - 1 : 0;

  let renderedItems =
    filteredItems?.[activeActionIndex] || currentAction?.[activeActionIndex];

  // query for fetching live order config
  const { data: liveOrderConfigData, refetch: fetchLiveOrderConfig } =
    useQueryCall({ enabled: false }, getLiveOrderConfig(orderId), [
      'live_order_config',
      orderId,
    ]);

  // query for fetching live order tasks
  const { refetch: fetchLiveOrderTasks } = useQueryCall(
    { enabled: false },
    null,
    ['live_order_tasks', orderId],
    () =>
      client(getTasksEndpoint(orderId, currentTaskListOffset)).then((tasks) => {
        if (!tasks?.length) return;
        setLiveOrderTasks((prev) => {
          const updatedTasks =
            currentTaskListOffset === 0 ? tasks : [...prev, ...tasks];
          setData((prev) => ({
            ...prev,
            [TAB_INDEXES.LIVE_ORDER]: {
              ...prev?.[TAB_INDEXES.LIVE_ORDER],
              items: updatedTasks,
            },
          }));
          if (
            updateTaskList ||
            (updatedTasks?.length > prev?.length && currentIndex === 0)
          ) {
            // Counts the number of "OPEN" tasks (from the latest) until a non-"OPEN" task is found.
            setNewTasksCount(() => {
              const reversedTasks = updatedTasks?.slice().reverse();
              let count = 0;

              for (let task of reversedTasks) {
                if (
                  task?.status?.slug === TASK_STATUSES.OPEN &&
                  liveOrderConfigData?.actions_allowed
                ) {
                  count++;
                } else {
                  break;
                }
              }
              if (count === updatedTasks?.length && prev?.length > 0) {
                count = Math.abs(updatedTasks?.length - prev?.length);
              }
              return count;
            });
            setCurrentAction((prev) => ({
              ...prev,
              [TAB_INDEXES.LIVE_ORDER]: {
                ...prev?.[TAB_INDEXES.LIVE_ORDER],
                items: updatedTasks,
              },
            }));
            setUpdateTaskList(false);
          }
          return updatedTasks;
        });
        setCurrentTaskListOffset((prev) => prev + tasks?.length);
        if (
          tasks?.length > 0 &&
          !isUpdatingTask &&
          liveOrderConfigData?.actions_allowed &&
          tasks[tasks.length - 1]?.status?.slug === TASK_STATUSES.OPEN
        ) {
          toast.success('New tasks assigned. Kindly check your task list.', {
            position: 'bottom-right',
            icon: <TableBooking color='#318616' size='18' />,
          });
          playNotificationSound();
        }
        setIsUpdatingTask(false);
      }),
  );

  //mutation to update live order task
  const { mutate: updateTask } = useMutationCall(
    {},
    null,
    ['update_live_order_task', orderId],
    {
      doNotShowSuccessToast: true,
    },
    ({
      taskId,
      orderId,
      status,
      subStatus,
      rejectionReason,
      updatedTaskType,
      updated_product_data,
    }) =>
      client(
        isPlayGroundMode
          ? PLAYGROUND_UPDATE_TASK_ENDPOINT
          : lifelineEndPoints.UPDATE_TASK,
        {
          data: {
            task_id: taskId,
            order_id: orderId,
            status: status,
            sub_status: subStatus,
            rejection_reason: rejectionReason,
            updated_task_type: updatedTaskType,
            updated_product_data: updated_product_data,
          },
        },
      )
        .then(() => {
          if (status === TASK_STATUSES.completed) {
            setUpdateTaskList(true);
            goBack();
          }
          setCurrentTaskListOffset(0);
        })
        .catch((err) => {
          toast.error(
            err?.message || 'Unable to update task. Please try again later.',
          );
        }),
  );

  const openActiveActionList = useCallback(
    (action, tabIndex) => {
      if (tabIndex === TAB_INDEXES.LIVE_ORDER) {
        setLoading(true);
        const obj = {
          items: liveOrderTasks || [],
          heading: 'Live Order Tasks',
          type: action?.type,
        };
        setData({
          ...data,
          [tabIndex]: obj,
        });
        setActions([
          {
            ...data,
            [tabIndex]: obj,
          },
        ]);
        setCurrentAction((prev) => ({
          ...prev,
          [tabIndex]: obj,
        }));
        setLoading(false);
      } else {
        let queryStrings = {
            order_id: orderId,
          },
          timeLineStatus = {};
        timeLineStatus[orderId] = false;
        setLoading(true);
        reasonModel
          .getReasons(action.url, queryStrings)
          .then((response) => {
            setIsTimelineUpdated(timeLineStatus);
            if (response?.version === 'v2') {
              setIsResolutionService(true);
            }

            // clearing the dsr_comment local state
            if (
              typeof localStorage !== 'undefined' &&
              localStorage.removeItem
            ) {
              localStorage.removeItem(DSR_COMMENT);
            }

            if (!response || (response && response.isError)) {
              setError(true);
              response?.message && setErrorMsg(response.message);
              setLoading(false);
              return;
            }

            if (action.url === 'issues/get_applicable_reasons') {
              RfoApplicableReasonsFetchedEvent({
                [MetricsForJumboEvent.order_id]: orderId,
                [MetricsForJumboEvent.cart_id]: cartId,
                [MetricsForJumboEvent.customer_id]: userId,
                [MetricsForJumboEvent.feature_meta]: {
                  applicable_reasons: JSON.stringify(
                    response.applicable_reasons,
                  ),
                },
              });
            }

            let obj = {
              items: response.applicable_reasons || response,
              heading: response?.is_dsr_flow
                ? 'Doorstep return complaints'
                : '',
              type: action.type,
              card: response?.cards,
            };

            if (response?.pending_issues_reasons?.length) {
              obj = {
                ...obj,
                pending_issues: response?.pending_issues_reasons,
              };
            }

            setData({
              ...data,
              [tabIndex]: obj,
            });
            setActions([
              {
                ...data,
                [tabIndex]: obj,
              },
            ]);
            setCurrentAction((prev) => ({
              ...prev,
              [tabIndex]: obj,
            }));
            setLoading(false);
          })
          .catch((err) => {
            setIsTimelineUpdated(timeLineStatus);
            setError(true);
            err?.message && setErrorMsg(err.message);
            setLoading(false);
          });
      }
    },
    [currentAction, data, orderId, setIsTimelineUpdated, liveOrderTasks],
  );

  const resetState = useCallback(() => {
    setLoading(true);
    setFilteredItems(null);
    setActions([]);
    setCurrentAction(null);
    setError(false);
  }, []);

  // sets the active tab index and opens the action list
  const openActiveActionDetails = useCallback(
    (tab, tabIndex) => {
      resetState();
      setActiveActionIndex(tabIndex);
      openActiveActionList(tab, tabIndex);
    },
    [resetState, openActiveActionList],
  );

  const handleCloseActionView = () => {
    localStorage.setItem(IS_SIDEBAR_CLOSE, 'false');
    dispatch(closeActionView(false));
  };

  const reloadSnippet = useCallback(() => {
    if (!isTimelineUpdated) return;
    if (isTimelineUpdated && actions?.length < 2) {
      openActiveActionDetails(links[activeActionIndex], activeActionIndex);
    }
    return true;
  }, [actions, activeActionIndex, isTimelineUpdated, openActiveActionDetails]);

  const searchAction = useCallback(
    (currentIndex) => (value) => {
      let matchedValues = actions?.[currentIndex]?.[
        activeActionIndex
      ]?.items.filter((item) => {
        return (
          item?.title?.toLowerCase().includes(value.toLowerCase()) ||
          item?.issues?.some((issue) =>
            issue?.title?.toLowerCase().includes(value.toLowerCase()),
          )
        );
      });

      if (value?.length && !matchedValues?.length) {
        setSearchedError(true);
      }

      let obj = {};
      obj = {
        ...currentAction[activeActionIndex],
        items: matchedValues,
      };
      setData({
        ...data,
        [activeActionIndex]: obj,
      });
      setFilteredItems({
        ...currentAction,
        [activeActionIndex]: obj,
      });

      setCurrentAction((prev) => ({
        ...prev,
        [activeActionIndex]: obj,
      }));
    },
    [actions, activeActionIndex, currentAction, data],
  );

  const setStateHandler = (obj) => {
    setData({
      ...data,
      [activeActionIndex]: obj,
    });
    setActions([
      ...actions,
      {
        ...data,
        [activeActionIndex]: obj,
      },
    ]);
    setCurrentAction((prev) => ({
      ...prev,
      [activeActionIndex]: obj,
    }));
    setLoading(false);
    return;
  };

  const makeIssueInfoCall = useCallback(
    (
      item,
      skipItemSelectionScreen,
      orderLevelPayload = {},
      updateTaskProps = {},
    ) => {
      if (activeActionIndex === TAB_INDEXES.LIVE_ORDER) {
        if (item) {
          if (
            updateTaskProps?.isUpdatingTask &&
            liveOrderConfigData?.actions_allowed
          ) {
            updateTask({
              taskId: item.id,
              orderId: orderId,
              status: updateTaskProps.status,
              subStatus: updateTaskProps.subStatus,
              rejectionReason: updateTaskProps.rejectionReason,
              updatedTaskType: updateTaskProps.updatedTaskType,
              updated_product_data: updateTaskProps.updated_product_data,
            });
            setIsUpdatingTask(true);
            if (updateTaskProps.status === TASK_STATUSES.completed) {
              return;
            }
          }
          let obj = {
            heading: `Task ${item.task_number}: ${item.title}`,
            items: [item],
            type: 'tasks',
            selectedValue: item.id,
          };
          setStateHandler(obj);
        }
        return;
      }
      let params = {};
      let url = item.url || item.id;
      const dataToSubmit = {
        order_id: orderId,
        cart_id: cartId,
        complaint_type: item?.slug,
      };
      if (!url && !dataToSubmit?.complaint_type) {
        setLoading(false);
        return;
      }
      params['order_id'] = orderId;
      if (item?.level === 'order_level' || skipItemSelectionScreen) {
        // log the issue click event for order level issues
        IssueClickEvent({
          [MetricsForJumboEvent.order_id]: orderId,
          [MetricsForJumboEvent.cart_id]: cartId,
          [MetricsForJumboEvent.customer_id]: userId,
          [MetricsForJumboEvent.feature_meta]: {
            request_type: dataToSubmit?.complaint_type || '',
            issue_level: 'order_level',
          },
        });

        let obj = {
          heading: item.title,
          subHeading: currentAction?.[activeActionIndex]?.heading,
          items: [],
          type: 'issue',
          selectedValue: item.slug,
          mediaValidation: item.media_validation_slug,
          skipItemSelectionScreen: skipItemSelectionScreen,
          complaintId: item.external_complaint_id,
          selected_items: item.selected_items,
          orderLevelPayload: orderLevelPayload,
        };

        setStateHandler(obj);
        return;
      }

      // response_meta is used to store metadata about the response in the jumbo event
      const response_meta = {};

      reasonModel
        .getIssuesInfo(url, params, dataToSubmit)
        .then((response) => {
          if (response && response.isError === true) {
            response_meta.is_success = false;
            setError(true);
            response.message && setErrorMsg(response.message);
            setLoading(false);
            return;
          }

          // populate response_meta with necessary data
          response_meta.is_success = true;

          // `url` here is `item.url || item.id` - for the CACR reason
          // (id 208) `item.url` is never set, so `url` is literally 208.
          // This response is the feasibility signal for the whole CACR
          // flow: `meta_info.text` says whether RFO is possible for this
          // order, and `submit_button` carries what the agent will see as
          // the final action ("Cancel Order" vs the RFO variant) along with
          // `submit_button_object.is_rfo_flow`.
          if (url === RFO_CACR_REASON_ID) {
            RfoIssueInfoResponseEvent({
              [MetricsForJumboEvent.order_id]: orderId,
              [MetricsForJumboEvent.cart_id]: cartId,
              [MetricsForJumboEvent.customer_id]: userId,
              [MetricsForJumboEvent.feature_meta]: {
                meta_info: response?.meta_info?.text,
                submit_button_text: response?.submit_button?.text,
                submit_button_enabled: response?.submit_button?.is_enabled,
                is_rfo_flow:
                  response?.submit_button?.submit_button_object?.is_rfo_flow,
                cancellation_reasons: JSON.stringify(
                  (response?.radio?.source || []).map((option) => ({
                    text: option.text,
                    value: option.value,
                  })),
                ),
              },
            });
          }

          const data =
            response?.multi_select_range?.source?.map((item) => {
              if (!item) return null;
              return {
                category_name: item.category_name || '',
                id: item.id || '',
                pickup_enabled: item.pickup_enabled || false,
                pickup_selected: item.pickup_selected || false,
                text: item.text || '',
                unit_cost: item.unit_cost || 0,
                substitutes_available: item.substitutes_available,
              };
            }) || [];
          response_meta.data = JSON.stringify(data);

          let obj = {
            heading: item.title,
            subHeading: currentAction?.[activeActionIndex]?.heading,
            items: [response],
            type: 'issue',
            selectedValue: item.id || item.slug,
            mediaValidation: item.media_validation_slug,
          };
          setStateHandler(obj);
        })
        .catch((err) => {
          response_meta.is_success = false;
          setError(true);
          err?.message && setErrorMsg(err.message);
          setLoading(false);
          return;
        })
        .then(() => {
          IssueClickEvent({
            [MetricsForJumboEvent.order_id]: orderId,
            [MetricsForJumboEvent.cart_id]: cartId,
            [MetricsForJumboEvent.customer_id]: userId,
            [MetricsForJumboEvent.feature_meta]: {
              request_type: dataToSubmit?.complaint_type || '',
              issue_level: 'item_level',
              ...(response_meta || {}),
            },
          });
        });
    },
    [actions, activeActionIndex, currentAction, data, orderId],
  );

  const getIssuesInfo = useCallback(
    (
      selectedItem,
      skipItemSelectionScreen = false,
      orderLevelPayload = {},
      updateTaskProps = {},
    ) => {
      if (selectedItem.disabled) return;

      if (selectedItem.id === RFO_CACR_REASON_ID) {
        RfoCacrOptionClickedEvent({
          [MetricsForJumboEvent.order_id]: orderId,
          [MetricsForJumboEvent.cart_id]: cartId,
          [MetricsForJumboEvent.customer_id]: userId,
          [MetricsForJumboEvent.feature_meta]: {
            reason_id: selectedItem.id,
            title: selectedItem.title,
          },
        });
      }

      setFilteredItems(null);
      if (selectedItem?.level != 'order_level') setLoading(true);
      if (issueRefID.current) {
        clearTimeout(issueRefID.current);
      }
      issueRefID.current = setTimeout(() => {
        if (selectedItem.type === 'group') {
          let obj = {
            heading: selectedItem.title,
            items: selectedItem.elements,
            isGrouped: true,
            selectedValue: selectedItem.id,
            mediaValidation: selectedItem.media_validation_slug,
            cancellationWarning: selectedItem.show_cancellation_warning
              ? selectedItem.cancellation_warning
              : null,
          };
          setData({
            ...data,
            [activeActionIndex]: obj,
          });
          setActions([
            ...actions,
            {
              ...data,
              [activeActionIndex]: obj,
            },
          ]);
          setCurrentAction((prev) => ({
            ...prev,
            [activeActionIndex]: obj,
          }));
          setLoading(false);
          return;
        }
        makeIssueInfoCall(
          selectedItem,
          skipItemSelectionScreen,
          orderLevelPayload,
          updateTaskProps,
        );
      }, 200);
    },
    [actions, activeActionIndex, currentAction, data, makeIssueInfoCall],
  );

  const goBack = useCallback(() => {
    setLoading(true);
    if (actionRefID.current) {
      clearTimeout(actionRefID.current);
    }
    actionRefID.current = setTimeout(() => {
      openActiveActionDetails(links[activeActionIndex], activeActionIndex);
    }, 200);
  }, [activeActionIndex, openActiveActionDetails]);

  const activeActionContentProps = {
    pageIndex: currentIndex,
    activeActionIndex,
    list: renderedItems,
    resetSmartplugState,
    orderId,
    cartId,
    userId,
    complaintType,
    setcomplaintType,
    handleCardLink,
    handleActionClick: getIssuesInfo,
    onSearchAction: searchAction,
    searchedError,
    isResolutionService,
    goBack,
    currentAction,
    liveOrderConfigData,
    newTasksCount,
  };

  useEffect(() => {
    if (
      activeActionIndex === TAB_INDEXES.LIVE_ORDER &&
      isLiveOrdersViewEnabled &&
      isLiveOrderViewAllowed
    ) {
      setLoading(true);
      fetchLiveOrderConfig().then(() => {
        fetchLiveOrderTasks().then(() => {
          setLoading(false);
        });
      });
    }

    // Polling for live order tasks (only for live orders with actions allowed)
    if (
      isLiveOrdersViewEnabled &&
      isLiveOrderViewAllowed &&
      liveOrderConfigData?.actions_allowed
    ) {
      const interval = setInterval(fetchLiveOrderTasks, POLL_INTERVAL);
      return () => clearInterval(interval);
    }
  }, [
    fetchLiveOrderTasks,
    isLiveOrderViewAllowed,
    isLiveOrdersViewEnabled,
    activeActionIndex,
    liveOrderConfigData,
    fetchLiveOrderConfig,
  ]);

  useEffect(() => {
    if (
      isLiveOrderViewAllowed &&
      isLiveOrdersViewEnabled &&
      liveOrderConfigData?.actions_allowed
    ) {
      fetchLiveOrderTasks();
    }
  }, [
    liveOrderConfigData?.actions_allowed,
    isLiveOrderViewAllowed,
    isLiveOrdersViewEnabled,
    currentTaskListOffset,
  ]);

  useEffect(() => {
    openActiveActionDetails(links[activeActionIndex], activeActionIndex);
    return () => {
      clearTimeout(issueRefID.current);
      clearTimeout(actionRefID.current);
    };
  }, []);

  useEffect(() => {
    isTimelineUpdated && reloadSnippet();
  }, [isTimelineUpdated]);

  // set the live order view allowed status
  useEffect(() => {
    if (orders && orders.length) {
      orders.forEach(({ order, task_section }) => {
        if (order && order.order_id === orderId) {
          setIsLiveOrderViewAllowed(
            task_section?.allow_live_order_task_section,
          );
        }
      });
    }
  }, [orders, orderId]);

  return (
    <ActionsView.Wrapper>
      {/* Header */}
      {!isActionViewClose &&
        (currentIndex === 0 ? (
          <Tabs
            activeIndex={activeActionIndex}
            links={links}
            setActiveAction={openActiveActionDetails}
            isLiveOrderViewEnabled={
              isLiveOrdersViewEnabled && isLiveOrderViewAllowed
            }
            liveOrderTasks={liveOrderTasks}
            showPing={
              isLiveOrdersViewEnabled &&
              isLiveOrderViewAllowed &&
              liveOrderConfigData?.actions_allowed
            }
            orderId={orderId}
          />
        ) : (
          <ActionsView.Header onClick={goBack}>
            <div className='tw-flex tw-items-start tw-gap-3'>
              <span className='iconMarginR'>
                <Back size={18} color={grey.z800} />
              </span>
              <div className='col'>
                <p className='semiBold large'>{renderedItems?.heading}</p>
                {renderedItems?.subHeading && (
                  <p className='lighter'>{renderedItems?.subHeading}</p>
                )}
              </div>
            </div>
            {isSmartPlug && (
              <p
                className='gotoBack icon iconMarginL pointer'
                onClick={setShowIssuesBox}
                role='button'
                tabIndex={0}
              >
                <img src={backArrow} alt='Go back' />
              </p>
            )}
          </ActionsView.Header>
        ))}

      {/* Selected Tab content loading */}
      {isLoading && !isActionViewClose && <LoadingUI />}

      {/* Error loading tab content  */}
      {isError && !isLoading && !isActionViewClose && (
        <EmptyState img={InvalidSearchImg} heading={errorMsg} />
      )}

      {/* Selected Tab content */}
      {!isLoading && !isError && renderedItems?.items && !isActionViewClose && (
        <>
          {!!actions?.[TAB_INDEXES.REPORT_ISSUE]?.[TAB_INDEXES.REPORT_ISSUE]
            ?.card && (
            <ActionsView.Card>
              <Card
                content={
                  actions?.[TAB_INDEXES.REPORT_ISSUE]?.[
                    TAB_INDEXES.REPORT_ISSUE
                  ]?.card
                }
                onClick={() =>
                  handleCardLink(
                    actions?.[TAB_INDEXES.REPORT_ISSUE]?.[
                      TAB_INDEXES.REPORT_ISSUE
                    ]?.card,
                  )
                }
              />
            </ActionsView.Card>
          )}
          <ActiveActionContent {...activeActionContentProps} />
        </>
      )}

      {isActionViewClose && dashboardMode !== 'smartplug' && isNewUI && (
        <SidebarUI
          handleCloseActionView={handleCloseActionView}
          openActiveActionDetails={openActiveActionDetails}
        />
      )}
    </ActionsView.Wrapper>
  );
};

ActionsView.Wrapper = styled.div`
  flex: 1;
  flex-direction: column;
  background: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  /* overflow: hidden; */
  border-radius: 1rem;
`;

ActionsView.Header = styled.div`
  padding: 2rem;
  background: #fff;
  box-shadow: 0px 1px 2px rgb(28 28 28 / 6%);
  cursor: pointer;
  justify-content: space-between;
`;

ActionsView.Card = styled.div`
  padding: 2rem 2rem 0;
`;
